/*
  PDP A/B test — shared group resolver.
  ------------------------------------------------------------------
  ONE source of truth for which arm of the shoes PDP test a shopper is in. Every feature
  in the test reads from here; nothing re-implements the precedence chain, which would
  otherwise drift between features and split the traffic inconsistently.

  Groups: 'control' (what is live today) | 'dropdown' (the test experience).

  Resolution order, first hit wins:
    1. ?pdp_ab= / ?dyn_stock=  — QA override, written to sessionStorage so it survives
                                 navigating the site. Deliberately outranks Intelligems.
    2. sessionStorage          — the sticky QA override from step 1.
    3. window.pdpAbGroup / window.dynStockAbGroup — what INTELLIGEMS sets.
    4. <html data-pdp-ab-group="…">               — alternative for IG's CSS/JS injection.
    5. DEFAULT_GROUP ('control') — a shopper Intelligems never reached sees exactly what
                                 is live today.

  Intelligems variant-group box needs only:
      window.pdpAbGroup = 'dropdown';
      if (window.pdpAb) window.pdpAb.setGroup('dropdown');
  The second line covers IG loading AFTER a feature has already painted: setGroup notifies
  subscribers so they can swap in place. IG's bundle is a module in <head> and the feature
  scripts are deferred, so either order is possible — features must not assume they ran first.

  Loaded before every feature script in the test (see layout/theme.liquid).
*/
(function () {
  if (window.pdpAb) return;

  var CONTROL = 'control';
  var DROPDOWN = 'dropdown';
  var PARAMS = ['pdp_ab', 'dyn_stock'];
  var STORAGE_KEY = 'pdpAbGroup';

  // The arm for anyone Intelligems has NOT assigned. Must stay CONTROL: control is the
  // experience that is already live, so an unassigned shopper sees no change, and the
  // test experience only ever reaches traffic IG has deliberately put in that group.
  // Set to DROPDOWN only for local preview, and set it straight back.
  var DEFAULT_GROUP = CONTROL;

  function normalize(value) {
    var g = String(value == null ? '' : value).trim().toLowerCase();
    return g === DROPDOWN || g === CONTROL ? g : null;
  }

  // Private browsing and "block site data" both THROW on access rather than returning
  // null, so every storage touch is guarded and simply degrades to no stickiness.
  function readStored() {
    try {
      return normalize(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function writeStored(group) {
    try {
      sessionStorage.setItem(STORAGE_KEY, group);
    } catch (e) {}
  }

  function fromUrl() {
    try {
      var params = new URL(window.location.href).searchParams;
      for (var i = 0; i < PARAMS.length; i += 1) {
        var hit = normalize(params.get(PARAMS[i]));
        if (hit) return hit;
      }
    } catch (e) {}
    return null;
  }

  function resolve() {
    var url = fromUrl();
    if (url) {
      writeStored(url);
      return url;
    }
    var sticky = readStored();
    if (sticky) return sticky;
    var ig = normalize(window.pdpAbGroup) || normalize(window.dynStockAbGroup);
    if (ig) return ig;
    var attr = normalize(document.documentElement.getAttribute('data-pdp-ab-group'));
    if (attr) return attr;
    return DEFAULT_GROUP;
  }

  var current = resolve();
  var listeners = [];

  function notify() {
    for (var i = 0; i < listeners.length; i += 1) {
      // One throwing subscriber must not stop the others from being told.
      try {
        listeners[i](current);
      } catch (e) {}
    }
  }

  window.pdpAb = {
    CONTROL: CONTROL,
    DROPDOWN: DROPDOWN,

    getGroup: function () {
      return current;
    },

    // Re-reads every source. Features call this on their own tick so a late Intelligems
    // assignment is picked up even if setGroup() was never called.
    refresh: function () {
      var next = resolve();
      if (next !== current) {
        current = next;
        notify();
      }
      return current;
    },

    // Returns false on an unrecognised value instead of throwing, so a typo in the
    // Intelligems box degrades to the control experience rather than breaking the PDP.
    setGroup: function (group) {
      var next = normalize(group);
      if (!next) return false;
      window.pdpAbGroup = next;
      if (next !== current) {
        current = next;
        notify();
      }
      return true;
    },

    // Fires on every change. Returns an unsubscribe function.
    onChange: function (fn) {
      if (typeof fn !== 'function') return function () {};
      listeners.push(fn);
      return function () {
        var i = listeners.indexOf(fn);
        if (i > -1) listeners.splice(i, 1);
      };
    },
  };
})();
